module.exports = __webpack_public_path__ + "img/cardBack.2bd33841.png";